<template>
    <div class="filter-content">
        <div v-if="providerName && selectedFilters.is_business && filters.familyOptions.length > 1"
             class="family-filter family-filter-mobile"
             :class="`content-${providerName}`"
        >
            <div class="family-filter-inner">
                <div v-for="(family, index) in filters.familyOptions"
                     :key="index"
                >
                    <input
                        :id="`family-${index}`"
                        :value="family.value"
                        v-model="selectedFilters.family_id"
                        type="radio"
                        name="family"
                        @change="onChangeFilters('family')"
                    >
                    <label :for="`family-${index}`">
                        {{ family.label }}
                    </label>
                </div>

            </div>
        </div>

        <div class="first-section d-none d-md-block"
             :class="{'first-section-family': providerName && selectedFilters.is_business && filters.familyOptions.length > 1}"
        >
            <div class="first-section-wrapper">
                <div v-if="!selectedFilters.is_renewal_site"
                     :class="['first-radio', { 'first-radio-home': !providerName}]"
                >
                    <p class="title-radio">Abonnement:</p>
                    <div :class="['content-radio', { 'content-radio-home': !providerName }]">
                        <div v-for="(abonament, index) in filters.typeOptions"
                             :key="index"
                        >
                            <input
                                :id="`abonament-${index}`"
                                :value="abonament.value"
                                v-model="selectedFilters.is_renewal"
                                type="radio"
                                name="abonament"
                                @change="onChangeFilters('is_renewal')"
                            >
                            <label :for="`abonament-${index}`">
                                {{ abonament.label }}
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="providerName && filters.discountOptions && filters.discountOptions.length"
                     class="second-radio"
                     :class="{'d-flex': selectedFilters.is_renewal_site}"
                >
                    <p class="title-radio me-1">Klantvoordeel:</p>
                    <div class="content-radio">
                        <div class="content-radio-wrapper">
                            <div>
                                <input
                                    :id="`discount-0`"
                                    :value="''"
                                    :checked="selectedFilters.discount === ''"
                                    v-model="selectedFilters.discount"
                                    type="radio"
                                    name="discount"
                                    @change="onChangeFilters('discount')"
                                >
                                <label :for="`discount-0`">
                                    Er zijn geen andere {{ $filters.capitalizeFirstLetter(providerName) }} abonnementen op mijn adres
                                </label>
                            </div>

                            <div v-for="(discount, index) in filters.discountOptions"
                                 :key="index"
                            >
                                <input
                                    :id="`discount-${index + 1}`"
                                    :value="discount.value"
                                    :checked="selectedFilters.discount !== ''"
                                    v-model="selectedFilters.discount"
                                    type="radio"
                                    name="discount"
                                    @change="onChangeFilters('discount')"
                                >
                                <label :for="`discount-${index + 1}`">
                                    {{ discount.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="second-section d-none d-md-block">
            <div :class="['second-section-wrapper', { 'second-section-wrapper-home': !providerName }]">
                <div v-if="selectedFilters.has_device" class="left-section">
                    <div  class="select-wrapper">
                        <select
                            v-model="selectedFilters.brand"
                            name="flt_brand"
                            class="form-select"
                            aria-label="Select brand"
                            @change="generateDevicesForSelectedBrand"
                        >
                            <option value="">Toestel merken</option>
                            <option v-for="(brand, index) in brands"
                                    :key="index"
                                    :value="brand"
                            >
                                {{ brand }}
                            </option>
                        </select>

                        <span class="arrow"></span>
                    </div>

                    <div class="select-wrapper">
                        <select
                            v-model="selectedFilters.model"
                            name="flt_device_type"
                            class="form-select"
                            aria-label="Select Device"
                            style="margin-bottom: 10px;"
                            @change="changeBreadcrumbsList"
                        >
                            <option value="" class="standard">Type toestel</option>
                            <option
                                v-for="(model, index) in models"
                                :key="index"
                                :value="model.name"
                            >
                                {{ model.name }}
                            </option>
                        </select>

                        <span class="arrow"></span>
                    </div>
                </div>

                <div v-if="!(!selectedFilters.has_device && !providerName)" :class="['right-section', { 'right-section-home': !providerName }]">
                    <div v-if="providerName" class="right-section-wrapper">
                        <div class="filter-belbundel">
                            <div v-if="isHollandsnieuwe(providerName)" class="filter-label">GB/min/sms:</div>
                            <div v-else class="filter-label">Belbundel:</div>

                            <div class="filter-values">
                                <div
                                    v-for="(minute, index) in filters.bundleOptions"
                                    :key="index"
                                >
                                    <input
                                        :id="`minutes-${index}`"
                                        :value="minute.value"
                                        v-model="selectedFilters.bundle"
                                        type="checkbox"
                                        name="minutes"
                                        @change="onChangeFilters('bundle')"
                                    >
                                    <label :for="`minutes-${index}`">
                                        {{ minute.label === 'onbeperkt' && isHollandsnieuwe(providerName) ? '10000' : minute.label }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div v-if="this.filters.speedOptions && this.filters.speedOptions.length > 1" class="filter-internet">
                            <div class="filter-label">Internet snelheid:</div>
                            <div v-for="(speed, index) in filters.speedOptions"
                                 :key="index"
                            >
                                <input
                                    :id="`internet-speed-${index}`"
                                    :value="speed.value"
                                    v-model="selectedFilters.internet_speed"
                                    type="radio"
                                    name="speed"
                                    @change="onFilter"
                                >
                                <label :for="`internet-speed-${index}`">
                                    {{ speed.label }}
                                </label>
                            </div>
                        </div>

                        <div v-if="!isHollandsnieuwe(providerName)" class="filter-databundel">
                            <div class="filter-label">Databundel:</div>
                            <div class="filter-values">
                                <div v-for="(internet, index) in filters.internetOptions"
                                     :key="index"
                                     class="column-radio"
                                >
                                    <input
                                        :id="`internet-${index}`"
                                        :value="internet.value"
                                        v-model="selectedFilters.internet"
                                        type="checkbox"
                                        name="internet"
                                        @change="onChangeFilters('internet')"
                                    >
                                    <label :for="`internet-${index}`">
                                        {{ internet.label }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="filter-contractsduur">
                            <div class="filter-label">Contractsduur:</div>
                            <div class="filter-values">
                                <div v-for="(duration, index) in filters.durationOptions"
                                     :key="index"
                                >
                                    <input
                                        :id="`duration-${index}`"
                                        :value="duration.value"
                                        v-model="selectedFilters.duration"
                                        type="checkbox"
                                        name="duration"
                                        @change="onFilter"
                                    >
                                    <label :for="`duration-${index}`">
                                        {{ duration.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="h-100">
                        <a v-if="carouselBanner" :href="carouselBanner.url" class="homepage-banners">
                            <img :src="carouselBanner.image_url" :alt="carouselBanner.name" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="first-section-mobile d-md-none">
            <div v-if="!selectedFilters.is_renewal_site" class="first-radio-mobile">
                <div class="content-radio">
                    <div v-for="(type, index) in filters.typeOptions"
                         :key="index"
                    >
                        <input
                            :id="`type-mobile-${index}`"
                            :value="type.value"
                            v-model="selectedFilters.is_renewal"
                            type="radio"
                            name="type-mobile"
                            @change="onChangeFilters('is_renewal')"
                        >
                        <label :for="`type-mobile-${index}`">
                            {{ type.label }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="select-section-mobile">
                <div class="select-wrapper">
                    <select
                        v-model="selectedFilters.brand"
                        name="flt_brand"
                        class="form-select"
                        aria-label="Select brand"
                        @change="generateDevicesForSelectedBrand"
                    >
                        <option value="">Toestel merken</option>
                        <option v-for="(brand, index) in brands"
                                :key="index"
                                :value="brand"
                        >
                            {{ brand }}
                        </option>
                    </select>

                    <span class="arrow"></span>
                </div>

                <div class="select-wrapper">
                    <select
                        v-model="selectedFilters.model"
                        name="flt_device_type"
                        class="form-select"
                        aria-label="Select Device"
                        style="margin-bottom: 10px;"
                        @change="changeBreadcrumbsList"
                    >
                        <option value="" class="standard">Type toestel</option>
                        <option v-for="(model, index) in models"
                                :key="index"
                                :value="model.name"
                        >
                            {{ model.name }}
                        </option>
                    </select>

                    <span class="arrow"></span>
                </div>
            </div>

            <div v-if="providerName">
                <div class="show-subscription text-center" id="show" @click="toggleFilterSection">
                    <p class="tab-radio">Selecteer inhoud abonnement</p>
                    <i class="fas fa-chevron-down fa-sm"></i>
                </div>

                <div v-if="showSubscriptionContent && filters.discountOptions && filters.discountOptions.length"
                     class="radio-1"
                >
                    <div class="second-radio">
                        <p class="tab-radio">Klantvoordeel:</p>
                        <div class="radio-section">
                            <div>
                                <input
                                    :id="`discount-mobile-0`"
                                    :value="''"
                                    :checked="!selectedFilters.discount"
                                    v-model="selectedFilters.discount"
                                    type="radio"
                                    name="discount-mobile"
                                    @change="onChangeFilters('discount')"
                                >
                                <label :for="`discount-mobile-0`">
                                    Er zijn geen andere {{ $filters.capitalizeFirstLetter(providerName) }} abonnementen op mijn adres
                                </label>
                            </div>

                            <div v-for="(discount, index) in filters.discountOptions"
                                 :key="index"
                            >
                                <input
                                    :id="`discount-mobile-${index}`"
                                    :value="discount.value"
                                    :checked="selectedFilters.discount"
                                    v-model="selectedFilters.discount"
                                    type="radio"
                                    name="discount-mobile"
                                    @change="onChangeFilters('discount')"
                                >
                                <label :for="`discount-mobile-${index}`">
                                    {{ discount.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="showSubscriptionContent" class="right-section">
                    <div class="right-section-wrapper">
                        <div class="filters-flt_bundle">
                            <div v-if="isHollandsnieuwe(providerName)" class="filter-label">GB/min/sms:</div>
                            <div v-else class="filter-label">Belbundel:</div>

                            <div class="filter-values">
                                <div v-for="(minute, index) in filters.bundleOptions"
                                     :key="index"
                                >
                                    <input
                                        :id="`minutes-mobile-${index}`"
                                        :value="minute.value"
                                        v-model="selectedFilters.bundle"
                                        type="checkbox"
                                        name="minutes-mobile"
                                        @change="onChangeFilters('bundle')"
                                    >
                                    <label :for="`minutes-mobile-${index}`">
                                        {{ minute.label }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div v-if="this.filters.speedOptions && this.filters.speedOptions.length > 1" class="filters-flt_connection_speed">
                            <div class="filter-label">Internet snelheid:</div>
                            <div v-for="(speed, index) in filters.speedOptions"
                                :key="index"
                            >
                                <input
                                    :id="`internet-speed-mobile-${index}`"
                                    :value="speed.value"
                                    v-model="selectedFilters.internet_speed"
                                    type="radio"
                                    name="speed-mobile"
                                    @change="onFilter"
                                >
                                <label :for="`internet-speed-mobile-${index}`">
                                    {{ speed.label }}
                                </label>
                            </div>
                        </div>

                        <div v-if="!isHollandsnieuwe(providerName)" class="filters-flt_databundle">
                            <div class="filter-label">Databundel:</div>
                            <div class="filter-values">
                                <div v-for="(internet, index) in filters.internetOptions"
                                     :key="index"
                                     class="column-radio"
                                >
                                    <input
                                        :id="`internet-mobile-${index}`"
                                        :value="internet.value"
                                        v-model="selectedFilters.internet"
                                        type="checkbox"
                                        name="internet-mobile"
                                        @change="onChangeFilters('internet')"
                                    >
                                    <label :for="`internet-mobile-${index}`">
                                        {{ internet.label }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="filters-flt_durations">
                            <div class="filter-label">Contractsduur:</div>
                            <div class="filter-values">
                                <div v-for="(duration, index) in filters.durationOptions"
                                     :key="index"
                                >
                                    <input
                                        :id="`duration-mobile-${index}`"
                                        :value="duration.value"
                                        v-model="selectedFilters.duration"
                                        type="checkbox"
                                        name="duration-mobile"
                                        @change="onFilter"
                                    >
                                    <label :for="`duration-mobile-${index}`">
                                        {{ duration.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="third-section">
            <ul class="nav nav-pills nav-abo-sim">
                <li :class="{ active: selectedFilters.has_device }"
                    @click="changeSelectedType(1)"
                >
                    <a class="nav-abo-sim-text">Abonnement met toestel</a>
                </li>

                <li :class="{ active: !selectedFilters.has_device }"
                    @click="changeSelectedType(0)"
                >
                    <div class="fill-bg">
                        <div class="fill"></div>
                    </div>
                    <a class="nav-abo-sim-text">Sim Only</a>
                </li>

                <li class="extra">
                    <a type="button" class="nav-abo-sim-text" href="#renewal-check-modal" data-bs-toggle="modal" role="button">
                        <span>
                            <span>Is jouw contract vrij? </span>
                            <span class="a-link">Check het hier!</span>
                        </span>
                    </a>
                </li>
            </ul>

            <div class="title-container">
                <h1 class="page-title">
                    <span v-if="family">{{ family.name_website }}</span>
                    <span v-html="pageTitle" />
                    <span v-if="selectedFilters.is_renewal_site">verlengen</span>
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
import {SORT_TYPE} from '../constants'
import {isHollandsnieuwe} from "../helper"
import SaveOfferModal from "../components/modals/SaveOfferModal";

export default {
    components: {
        SaveOfferModal
    },

    props: {
        filters: {
            type: Object,
            required: true
        },

        providerName: {
            type: String,
            default: ''
        },

        family: {
            type: Object,
            default: null
        },

        carouselBanners: {
            type: Array,
            default: []
        },

        devices: {
            type: Object,
            default: {}
        },

        selectedFilters: {
            type: Object,
            required: true
        }
    },

    created() {
        this.sortTypes = SORT_TYPE

        if (this.selectedFilters.brand) {
            this.generateDevicesForSelectedBrand()
        }
    },

    beforeMount() {
        this.$emitter.$on('search-select', this.onSearchSelect);
    },

    data() {
        return {
            sortTypes: {},
            models: [],
            showSubscriptionContent: true,
            isModalVisible: false
        }
    },

    computed: {
        brands() {
            if (!this.devices) {
                return [];
            }
            return Object.keys(this.devices)
        },

        pageTitle() {
            if (this.providerName) {
                var providerName = `<span class="text-${this.providerName}">${this.$filters.capitalizeFirstLetter(this.providerName)}</span>`;

                if (!this.selectedFilters.has_device) {
                    return `${providerName} abonnement zonder toestel`
                }

                if (this.selectedFilters.model) {
                    return `${providerName} ${this.selectedFilters.model} abonnement`
                }

                if (this.selectedFilters.brand) {
                    return `${this.selectedFilters.brand} met ${providerName} abonnement`
                }

                return `${providerName} abonnement`
            }

            if (!this.selectedFilters.has_device) {
                return 'Abonnement zonder toestel'
            }

            if (this.selectedFilters.model) {
                return this.selectedFilters.model
            }

            if (this.selectedFilters.brand) {
                return this.selectedFilters.brand
            }

            return 'Abonnementen met toestellen'
        },

        carouselBanner() {
            if (!this.carouselBanners.length) {
                return null
            }

            return this.carouselBanners[0]
        }
    },

    methods: {
        isHollandsnieuwe,
        onSearchSelect(option) {
            this.selectedFilters.brand = option.brand
            this.selectedFilters.model = option.model

            this.generateDevicesForSelectedBrand()
            this.onFilter()
        },

        generateDevicesForSelectedBrand() {
            if (!this.selectedFilters.brand) {
                this.models = []
            } else {
                this.models = Object.values(this.devices[this.selectedFilters.brand]);
            }

            let modelBelongsToBrand = this.models.some(item => item.name === this.selectedFilters.model)

            if (!modelBelongsToBrand) {
                this.selectedFilters.model = '';
            } else {
                const selectedModel = this.models.find(model => model.name === this.selectedFilters.model);
                if (selectedModel && selectedModel.type === 'future') {
                    this.onFutureModel(selectedModel);
                }
            }

            this.onFilter()
            this.onGenerateBreadcrumbs()
        },

        changeSelectedType(value) {
            this.selectedFilters.has_device = value;

            this.onChangeFilters('has_device')
            this.onGenerateBreadcrumbs()
        },

        toggleFilterSection() {
            this.showSubscriptionContent = !this.showSubscriptionContent;
        },

        changeBreadcrumbsList() {
            const selectedModel = this.models.find(model => model.name === this.selectedFilters.model);

            if (selectedModel && selectedModel.type === 'future') {
                this.onFutureModel(selectedModel);
            }

            this.onFilter();

            this.onGenerateBreadcrumbs()
        },

        onGenerateBreadcrumbs() {
            this.$emit('generateBreadcrumbs')
        },

        onFilter() {
            this.$emit('filter')
        },

        onFutureModel(selectedModel) {
            this.$emit('futureModel', selectedModel);
        },

        onChangeFilters(type) {
            this.$emit('filter-change', type)
        },

        openModal(index) {
            if (index === 1 && this.providerName === 'odido') {
                $('#save-offer-modal').modal('show');
            }
        }
    }
}
</script>
